/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { queryOptions, useQuery } from "@tanstack/react-query";

// Services
import { AuthService } from "@/services/auth.service";
import usePhysiomKineStore from "@/stores/physiomKine";

/* -------------------------------------------------------------------------- */
/*                                   Me Hook                                  */
/* -------------------------------------------------------------------------- */
const authService = new AuthService();

const meQueryOptions = queryOptions({
  queryFn: authService.me,
  queryKey: ["me"],
});

const useMe = () => {
  const { data, isPending } = useQuery(meQueryOptions);

  const store = usePhysiomKineStore();

  if (data !== store.user) {
    store.login(data);
  }

  return {
    data,
    isPending,
  };
};

export { useMe, meQueryOptions };
